import * as React from 'react';
import styled from 'styled-components';
import logo from '../../assets/sunbit-logo-orange.svg';
import { ProgressBwV2, Step } from '../progress-bw-v2/ProgressBwV2';

export type { Step };

const STopContainer = styled.header`
  width: 100%;
`;

const STop = styled.div<{ withShadow: boolean }>(
  ({ theme, withShadow }) => `
  width: 100%;
  z-index: 999;
  
  @media only screen and ${theme.device.max.laptopS} {
    box-shadow: ${
      withShadow ? '0px 2px 4px -2px rgba(24, 39, 75, 0.12), 0px 4px 4px -2px rgba(24, 39, 75, 0.08)' : 'none'
    };
  }
`
);

const STopBarSection = styled.section<{ withShadow: boolean }>(
  ({ theme, withShadow }) => `
  display: flex;
  height: 55px;
  justify-content: center;
  align-items: center;
  box-shadow: ${
    withShadow ? '0px 2px 4px -2px rgba(24, 39, 75, 0.12), 0px 4px 4px -2px rgba(24, 39, 75, 0.08)' : 'none'
  };
  @media only screen and (min-width: 800px) {
    height: 68px;
    padding:0 ${theme.spacing.huge}px;
  }
  @media only screen and ${theme.device.max.laptopS} {
    box-shadow: none;
  }
`
);

const SLogoSection = styled.div(
  ({ theme }) => `
  height: 38px;
  
  @media only screen and ${theme.device.max.laptopS} {
    height: 26px;
  }
`
);

const SLogo = styled.a`
  width: 100%;
  height: 100%;
  > img {
    width: 100%;
    height: 100%;
    display: inline-block;
  }
  @media only screen and (min-width: 800px) {
  }
`;

export interface ITopProps {
  currentStepNumber?: number;
  steps?: Step[];
  currentStepProgress?: number;
}

export const Top: React.FC<ITopProps> = ({ currentStepNumber, steps, currentStepProgress }) => {
  const withProgress: boolean = !!currentStepNumber && !!steps?.length;
  return (
    <STopContainer>
      <STop withShadow={!withProgress}>
        <STopBarSection withShadow={!withProgress}>
          <SLogoSection>
            <SLogo href="https://www.sunbit.com" data-at="sunbitLogoLink" target="_blank" rel="noreferrer">
              <img src={logo} alt="sunbit logo" />
            </SLogo>
          </SLogoSection>
        </STopBarSection>
        {withProgress && (
          <ProgressBwV2 steps={steps} currentStepNumber={currentStepNumber} currentStepProgress={currentStepProgress} />
        )}
      </STop>
    </STopContainer>
  );
};
